var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.855,
    height: 14.501,
    viewBox: "0 0 17.855 14.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M16.019,6.995c.011.159.011.317.011.476A10.34,10.34,0,0,1,5.619,17.882,10.341,10.341,0,0,1,0,16.239a7.57,7.57,0,0,0,.884.045,7.329,7.329,0,0,0,4.543-1.563,3.666,3.666,0,0,1-3.421-2.538,4.615,4.615,0,0,0,.691.057,3.87,3.87,0,0,0,.963-.125A3.66,3.66,0,0,1,.725,8.524V8.479a3.685,3.685,0,0,0,1.654.464A3.665,3.665,0,0,1,1.246,4.049,10.4,10.4,0,0,0,8.791,7.878,4.131,4.131,0,0,1,8.7,7.04a3.663,3.663,0,0,1,6.333-2.5,7.2,7.2,0,0,0,2.322-.884,3.649,3.649,0,0,1-1.609,2.017A7.336,7.336,0,0,0,17.855,5.1a7.866,7.866,0,0,1-1.835,1.892Z",
    transform: "translate(0 -3.381)",
    fill: "#e5bf00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.815e850c758fe2b5997dd31715316105.svg";
export { ForwardRef as ReactComponent };